module.exports = __webpack_public_path__ + "img/zanwusz.dae4d0f6.png";